import { create } from "zustand";

interface CommandModalState {
  isOpen: boolean;
}

interface CommandModalActions {
  open: () => void;
  close: () => void;
}

type CommandModalStore = CommandModalState & CommandModalActions;

export const useCommandModalStore = create<CommandModalStore>()((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));

export const selectCommandModalOpen = (state: CommandModalStore) => state.isOpen;
export const selectOpenCommandModal = (state: CommandModalStore) => state.open;
export const selectCloseCommandModal = (state: CommandModalStore) => state.close;
